<template>
  <div class="ui segment">
    <div class="ui middle aligned divided list">
      <div class="item" v-if="nrOfKeywords > 5">
        <h1 class="ui header">
          <span class="number">
            <div class="ui orange horizontal huge label">
              {{ nrOfFoundKeywords }}/{{ nrOfKeywords }}
            </div>
          </span>
        </h1>
      </div>
      <div
        class="item"
        :class="{ disabled: !clockIsRunning && !reviewModeEnabled }"
        :data-keyword-id="keywordId"
        v-for="(keyword, keywordId) in keywords"
        :key="keywordId"
        @click.stop="
          isHost &&
            clockIsRunning &&
            !keyword.found &&
            clickedKeyword(keyword.id)
        "
      >
        <div class="content">
          <h1
            class="ui header"
            :class="{
              'pulse animated': keyword.found,
              [keyword.color]:
                keyword.color && (keyword.found || reviewModeEnabled)
            }"
          >
            <span class="number" :class="{ orange: keyword.found }">
              {{
                keyword.found
                  ? keyword.score
                  : isHost && clockIsRunning
                  ? `[ ${keys[keywordId]} ]`
                  : ''
              }}
            </span>
            <span
              class="keyword"
              :class="{
                blurred: !reviewModeEnabled && !keyword.found && !isHost,
                striked: !reviewModeEnabled && keyword.found && isHost
              }"
            >
              {{
                !isPremium && !isHost && (keyword.found || reviewModeEnabled)
                  ? 'Gratis Basisversie...'
                  : keyword.name
              }}
            </span>
            <div
              class="ui green horizontal label"
              v-if="keyword.foundBy && (isHost || reviewModeEnabled)"
            >
              {{ keyword.foundBy | middleTruncate }}
            </div>
          </h1>
        </div>
      </div>
      <div class="item">
        <h1 class="ui header">
          <span class="number">
            <div class="ui orange horizontal huge label">
              {{ nrOfFoundKeywords }}/{{ nrOfKeywords }}
            </div>
          </span>
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import sounds from '@/sounds';
import Mousetrap from 'mousetrap';
import { KEYBOARD_KEYS } from '@/config';
import alertify from 'alertify.js';

export default {
  name: 'keyword-panel',
  props: ['keywords'],
  data() {
    return {
      keys: KEYBOARD_KEYS
    };
  },
  computed: {
    ...mapGetters([
      'clockIsRunning',
      'isHost',
      'isPremium',
      'reviewModeEnabled'
    ]),
    nrOfKeywords() {
      return this.keywords.length;
    },
    nrOfFoundKeywords() {
      return this.keywords.filter(keyword => keyword.found).length;
    }
  },
  created() {
    this.addKeyboardShortcuts();
  },
  methods: {
    clickedKeyword(keywordId) {
      this.$emit('clickedKeyword', keywordId);
      if (this.isHost) sounds.emitSound(sounds.AUDIO.CORRECT);
    },
    addKeyboardShortcuts() {
      Mousetrap.bind(this.keys, e => {
        if (this.isPremium) {
          const index = this.keys.indexOf(e.key);
          // -> add qwerty & numeric support
          const keywordId =
            index > 9 ? index - Math.floor(index / 10) * 10 : index;
          const keywordItem = document.querySelector(
            `[data-keyword-id='${keywordId}']`
          );
          if (keywordItem) keywordItem.click();
        } else {
          alertify.log(
            'Deze sneltoets is niet mogelijk in de gratis basisversie.'
          );
        }
        return false;
      });
    }
  }
};
</script>

<style scoped>
.ui.segment {
  padding-top: 1em;
  padding-bottom: 1em;
}
.ui.header {
  font-size: 2rem;
  line-height: 1.5em;
}
@media only screen and (max-width: 991px) {
  .ui.header {
    font-size: 2.3rem;
  }
}
.flip-list-move {
  transition: transform 1s;
}
.orange {
  color: #f2711c;
}
.number {
  min-width: 1.7em;
  display: inline-block;
}
.keyword {
  cursor: pointer;
}
.keyword.striked {
  text-decoration: line-through;
  cursor: default;
}
.keyword.blurred {
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-shadow: 0 0 30px rgba(0, 0, 0, 0.75);
  color: rgba(0, 0, 0, 0);
  zoom: 1;
  cursor: default;
}
</style>
